import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { bindActionCreators } from 'redux'
import { captureException } from 'utils/SentryHelpers'

import { api } from 'app/modules/playbook/api'

import { PlaybookStatus } from 'app/modules/playbook/constants'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'

import DisableSalesSequenceConfirmModal from './component'

const mapStateToProps = state => ({
  disableSalesSequenceModalVisible: PlaybookSelectors.getDisableSalesSequenceModalVisible(state),
  draft: PlaybookSelectors.draft(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    hideDisableSalesSequenceModal: PlaybookActions.hideDisableSalesSequenceModal,
    setDraftStatus: PlaybookActions.setDraftStatus,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onCloseClick: ({ actions: { hideDisableSalesSequenceModal }}) => () => {
      hideDisableSalesSequenceModal()
    },
    onDisableClick: ({ actions: { hideDisableSalesSequenceModal, setDraftStatus }, draft }) => () => {
      // Send (bulk) unenrollment request to the backend and update the playbook status and disable playbook.
      // If the request errors out, do not set the draft status to DISABLED.
      try {
        api.disableSalesSequenceById(draft.id)
        setDraftStatus({ status: PlaybookStatus.DISABLED })
      } catch(err) {
        captureException(err)
      }

      hideDisableSalesSequenceModal()
    },
  }),
)(DisableSalesSequenceConfirmModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/DisableSalesSequenceConfirmModal/index.js